<template>
    <div class="news">
        <siteHeader />
        <img src="@/assets/1747793251984.jpg" alt="main image" class="main-image">
        <div class="news-container">
            <div class="news-intro-card">
                <h2 class="card-title">政策法规 <span class="english-subtitle">Policy and Regulations</span></h2>
                <div class="news-content-area">
                    <div class="news-sidebar">
                        <h3>政策法规</h3>
                        <ul>
                            <li v-for="tab in tabs" :key="tab.type" @click="handleTabChange(tab.type)"
                                :class="{ active: currentType === tab.type }">
                                {{ tab.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="news-content">
                        <h3>{{ currentTabName }}</h3>
                        <ul class="policy-list">
                            <li v-for="item in policyList" :key="item.id" class="policy-item" @click="goToDetail(item)">
                                <span class="policy-title">{{ item.title }}</span>
                                <span class="policy-date">{{ item.releaseTime }}</span>
                            </li>
                        </ul>
                        <p v-if="!policyList || policyList.length === 0">暂无政策</p>

                        <div class="pagination">
                            <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">上一页</button>
                            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                                :class="{ active: currentPage === page }">
                                {{ page }}
                            </button>
                            <button @click="goToPage(currentPage + 1)"
                                :disabled="currentPage === totalPages">下一页</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <siteFooter />
    </div>
</template>

<script>
import siteHeader from '@/components/SiteHeader.vue'
import siteFooter from '@/components/SiteFooter.vue'
import { websiteApi } from '@/api'

export default {
    name: 'PolicyPage',
    components: {
        siteHeader,
        siteFooter
    },
    data() {
        return {
            currentType: '1',
            tabs: [
                { name: '政策解读', type: '1' },
                { name: '法律规章', type: '2' },
                { name: '行业标准', type: '3' }
            ],
            policyList: [],
            loading: false,
            currentPage: 1,
            pageSize: 6,
            total: 0
        }
    },
    computed: {
        currentTabName() {
            const tab = this.tabs.find(tab => tab.type === this.currentType)
            return tab ? tab.name : ''
        },
        totalPages() {
            return Math.ceil(this.total / this.pageSize)
        }
    },
    created() {
        this.fetchPolicyList()
    },
    methods: {
        async fetchPolicyList() {
            try {
                this.loading = true
                const response = await websiteApi.getLtCodificationDalist({
                    type: this.currentType,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                if (response.code === 200) {
                    this.policyList = response.rows || []
                    this.total = response.total || 0
                }
            } catch (error) {
                console.error('获取政策列表失败:', error)
            } finally {
                this.loading = false
            }
        },
        goToDetail(item) {
            this.$router.push({
                name: 'details',
                query: {
                    id: item.id,
                    type: this.currentType,
                    title: item.title,
                    releaseTime: item.releaseTime,
                    from: 'policy',
                    policyList: this.policyList
                }
            })
        },
        handleTabChange(type) {
            this.currentType = type
            this.currentPage = 1
            this.fetchPolicyList()
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page
                this.fetchPolicyList()
            }
        }
    }
}
</script>

<style scoped>
.main-image {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
}

.news-container {
    display: flex;
    padding: 20px;
    max-width: 1200px;
    margin: 20px auto;
    margin-top: -50px;
    flex-direction: column;
}

.news-intro-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.news-intro-card .card-title {
    color: #333;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.news-intro-card .card-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #3c4a6b;
}

.news-intro-card .english-subtitle {
    font-size: 20px;
    color: #666;
    font-weight: normal;
}

.news-content-area {
    display: flex;
    gap: 40px;
    margin-top: 20px;
}

.news-sidebar {
    width: 200px;
}

.news-sidebar ul {
    list-style: none;
    padding: 0;
}

.news-sidebar li {
    cursor: pointer;
    padding: 10px 15px;
    margin-bottom: 10px;
    background-color: #3c4a6b;
    color: white;
    border-radius: 4px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
    text-align: center;
}

.news-sidebar li:hover {
    background-color: #2c3e50;
    opacity: 0.9;
}

.news-sidebar li.active {
    background-color: #888;
    font-weight: bold;
}

.news-content {
    flex-grow: 1;
}

.policy-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.policy-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    transition: background-color 0.3s ease;
    cursor: pointer;
}

.policy-item:last-child {
    border-bottom: none;
}

.policy-item:hover {
    background-color: #f9f9f9;
}

.policy-title {
    font-size: 1em;
    color: #333;
    margin-right: 20px;
    flex-grow: 1;
    position: relative;
    padding-left: 15px;
}

.policy-title::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #3c4a6b;
    font-size: 1.2em;
    line-height: 1;
}

.policy-date {
    font-size: 0.9em;
    color: #666;
    flex-shrink: 0;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.pagination button {
    margin: 0 5px;
    padding: 8px 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.pagination button:hover:not(:disabled) {
    background-color: #f0f0f0;
}

.pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.pagination button.active {
    background-color: #3c4a6b;
    color: white;
    border-color: #3c4a6b;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .news-container {
        padding: 15px;
        margin: 20px 10px;
        margin-top: -30px;
    }

    .news-intro-card {
        padding: 20px;
        border-radius: 8px;
    }

    .news-intro-card .card-title {
        font-size: 20px;
    }

    .news-intro-card .english-subtitle {
        font-size: 16px;
        display: block;
        margin-top: 5px;
    }

    .news-content-area {
        flex-direction: column;
        gap: 20px;
        margin-top: 15px;
    }

    .news-sidebar {
        width: 100%;
    }

    .news-sidebar h3 {
        font-size: 16px;
        margin-bottom: 10px;
    }

    .news-sidebar ul {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        padding-bottom: 5px;
    }

    .news-sidebar li {
        min-width: 100px;
        flex-shrink: 0;
        padding: 8px 12px;
        margin-bottom: 0;
        font-size: 14px;
    }

    .news-content h3 {
        font-size: 18px;
        margin-bottom: 15px;
    }

    .policy-item {
        flex-direction: column;
        align-items: flex-start;
        padding: 12px 0;
        gap: 8px;
    }

    .policy-title {
        font-size: 15px;
        margin-right: 0;
        padding-left: 12px;
    }

    .policy-date {
        font-size: 12px;
        padding-left: 12px;
    }

    .pagination button {
        padding: 6px 12px;
        font-size: 14px;
        margin: 0 3px;
    }
}

@media screen and (max-width: 480px) {
    .news-container {
        padding: 10px;
        margin: 15px 5px;
        margin-top: -20px;
    }

    .news-intro-card {
        padding: 15px;
    }

    .news-intro-card .card-title {
        font-size: 18px;
    }

    .news-intro-card .english-subtitle {
        font-size: 14px;
    }

    .policy-title {
        font-size: 14px;
    }

    .policy-date {
        font-size: 11px;
    }

    .pagination button {
        padding: 5px 10px;
        font-size: 12px;
    }
}
</style>